import { EditOutlined } from "@ant-design/icons";
import { Form, Space } from "antd";
import React, { useEffect, useCallback } from "react";
import { useState } from "react";
import { addCountry, getCountries, updateCountry } from "../../api/CountryApi";
import AdnMessageError from "../common/adnMessage/AdnMessageError";
import AdnMessageSuccess from "../common/adnMessage/AdnMessageSuccess";
import { appTitle } from "../common/GeneralConfigurations";
import { CountryListPageForm } from "./CountryListPageForm";
import { useTranslation } from "react-i18next";

export const ManageCountryListPage = () => {
  const { t } = useTranslation();
  const title = t("country.title");
  const [countries, setCountries] = useState([]);
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [modalCountryId, setModalCountryId] = useState(null);
  const [refetchData, setRefetchData] = useState(0);
  const [orderBy, setOrderBy] = useState("");
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);

  useEffect(() => {
    document.title = `${appTitle} - ${title}`;
  }, [title]);

  const fetchData = useCallback(() => {
    getCountries(orderBy)
      .then((res) => {
        if (res.data) {
          setCountries(res.data);
        } else {
          setCountries([]);
        }
        setLoading(false);
      })
      .catch((err) => console.log(err));
  }, [orderBy]);

  useEffect(() => {
    fetchData();
  }, [refetchData, fetchData]);

  const handleOrderList = (pag, filter, sorter) => {
    sorter.order === "descend"
      ? setOrderBy("-" + sorter.field)
      : sorter.order === "ascend"
      ? setOrderBy(sorter.field)
      : setOrderBy("");
  };

  const addCountryModal = () => {
    setVisible(true);
    setModalCountryId(null);
    form.setFieldsValue({ name: "", code: "" });
  };
  const columns = [
    {
      title: t("country.columns.code"),
      dataIndex: "code",
      key: "code",
      width: "10%",
      sorter: true,
    },
    {
      title: t("country.columns.name"),
      dataIndex: "name",
      key: "name",
      width: "50%",
      sorter: true,
    },
    {
      title: t("country.columns.action"),
      key: "action",
      width: "10%",
      render: (text, record) => (
        <Space size="middle">
          <EditOutlined
            style={{ color: "black" }}
            onClick={() => {
              setVisible(true);
              setModalCountryId(record.id);
              form.setFieldsValue(record);
            }}
          />
        </Space>
      ),
    },
  ];

  const handleFinish = (values) => {
    setSubmitLoading(true);
    if (!modalCountryId) {
      addCountry(values)
        .then((res) => {
          setSubmitLoading(false);
          if (res.status === 201) {
            setRefetchData(refetchData + 1);
            AdnMessageSuccess();
          } else if (res.status === 400) {
            form.setFields(
              res.data.errors.map((e) => ({
                name: e.message.split(" ")[0].toLowerCase(),
                errors: [e.message],
              }))
            );
            return;
          } else AdnMessageError();
          setVisible(false);
        })
        .catch((err) => console.log(err));
    } else {
      updateCountry(modalCountryId, values)
        .then((res) => {
          setSubmitLoading(false);
          if (res.status === 200) {
            setRefetchData(refetchData + 1);
            AdnMessageSuccess();
          } else if (res.status === 400) {
            form.setFields(
              res.data.errors.map((e) => ({
                name: e.message.split(" ")[0].toLowerCase(),
                errors: [e.message],
              }))
            );
            return;
          } else AdnMessageError();
          setVisible(false);
        })
        .catch((err) => console.log(err));
    }
  };
  const handleBlurName = () => {
    form.setFieldsValue({
      name: form
        .getFieldValue("name")
        ?.trim()
        .split(/\s+/)
        .filter((w) => w !== "")
        .join(" "),
    });
    form.validateFields(["name"]);
  };

  return (
    <CountryListPageForm
      form={form}
      title={title}
      columns={columns}
      handleOrderList={handleOrderList}
      setVisible={setVisible}
      visible={visible}
      countries={countries}
      addCountryModal={addCountryModal}
      handleFinish={handleFinish}
      modalCountryId={modalCountryId}
      loading={loading}
      submitLoading={submitLoading}
      handleBlurName={handleBlurName}
    />
  );
};
